module.exports = __webpack_public_path__ + "media/images/Croix fermer-f4f1b0eab531bb4284afc777a4dbe178.svg";